import { Link } from 'react-router-dom';
import { usePageMeta, Reveal } from '../lib/site';
import { CardHeader } from '../components/Bits';
import ShotFrame from '../components/ShotFrame';
import PartnerFrame from '../components/PartnerFrame';
import shopShot from '../assets/shots/shop-products.jpg';

const row = {
  display: 'flex', gap: 10, alignItems: 'baseline',
  padding: '11px 0', borderBottom: '1px solid var(--line-soft)', fontSize: '0.96rem',
};
const dot = { width: 7, height: 7, borderRadius: '50%', background: 'var(--fairway)', flexShrink: 0, position: 'relative', top: -2 };

export default function Partners() {
  usePageMeta(
    'For suppliers and brands | MyGolfLinks',
    'The MGL Partner Portal puts supplier catalogs inside the ordering flow courses use every week. Brands can also sell direct to players through the app shop.'
  );

  return (
    <main>
      <section style={{ padding: 'clamp(140px, 16vw, 180px) 0 clamp(48px, 6vw, 72px)' }}>
        <div className="wrap">
          <Reveal>
            <p className="mono" style={{ fontSize: 12.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--fairway)', fontWeight: 500, marginBottom: 20 }}>
              For suppliers and brands
            </p>
            <h1 className="display" style={{ maxWidth: 760 }}>Sell where courses already buy.</h1>
            <p className="lede" style={{ margin: '24px 0 32px' }}>
              The MGL Partner Portal puts your catalog inside the ordering flow courses use every
              week, with orders and business messaging in the same place.
            </p>
            <Link to="/demo" className="btn btn-gold">Talk to the team</Link>
          </Reveal>
        </div>
      </section>

      <section className="band-card">
        <div className="wrap" style={{ padding: 'clamp(60px, 8vw, 96px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal>
            <CardHeader no="01" label="Two ways in" />
          </Reveal>
          <Reveal className="g2" d={1}>
            <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '28px 30px' }}>
              <h3 className="h3">Wholesale suppliers</h3>
              <p style={{ color: 'var(--mut)', fontSize: '0.95rem', margin: '10px 0 14px' }}>
                Pro shop and F&B vendors selling to courses.
              </p>
              <div>
                <div style={row}><span style={dot} />Your catalog, with your pricing, in front of every connected course</div>
                <div style={row}><span style={dot} />Orders come in through the platform instead of voicemail</div>
                <div style={row}><span style={dot} />Business messaging with the course, tied to the account</div>
                <div style={row}><span style={dot} />Courses see order history and stock visibility on your items</div>
              </div>
            </div>
            <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '28px 30px' }}>
              <h3 className="h3">Brands</h3>
              <p style={{ color: 'var(--mut)', fontSize: '0.95rem', margin: '10px 0 14px' }}>
                Equipment and consumer golf brands.
              </p>
              <div>
                <div style={row}><span style={dot} />Everything wholesale suppliers get, for your course accounts</div>
                <div style={row}><span style={dot} />Sell direct to players through the shop inside the app</div>
                <div style={row}><span style={dot} />Your offers reach golfers where their rounds already live</div>
              </div>
            </div>
          </Reveal>
          <Reveal d={2} style={{ marginTop: 30 }}>
            <p style={{ fontSize: '0.95rem', color: 'var(--mut)', maxWidth: '62ch' }}>
              Orders placed through the platform carry a 3% platform fee, paid by the supplier.
              That is the whole price of being here, and the course pays nothing to order from you.
            </p>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ padding: 'clamp(60px, 8vw, 96px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal>
            <CardHeader no="02" label="What partners see" />
            <h2 className="h2" style={{ maxWidth: 640 }}>Your products, in front of golfers and courses</h2>
            <p className="lede" style={{ marginTop: 16 }}>
              The real portal: your storefront as it appears to you, and the dashboard that tracks
              what sells.
            </p>
          </Reveal>
          <Reveal d={1} style={{ marginTop: 38 }}>
            <ShotFrame
              src={shopShot}
              alt="The MGL Partner Portal shop products page showing six live branded products with prices and stock levels"
              caption="MGL Partner Portal · your storefront in the player shop"
              domain="partner.mygolflinks.com"
            />
          </Reveal>
          <Reveal d={2} style={{ marginTop: 34, display: 'grid', justifyItems: 'center' }}>
            <PartnerFrame maxWidth={720} />
          </Reveal>
        </div>
      </section>

      <section className="band-pine on-pine">
        <div className="wrap" style={{ padding: 'clamp(64px, 9vw, 100px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal style={{ maxWidth: 620 }}>
            <h2 className="h2">Get your catalog in front of courses</h2>
            <p className="lede" style={{ margin: '16px 0 28px' }}>
              Tell us what you sell and who you already work with. We'll show you the portal on a
              short call.
            </p>
            <Link to="/demo" className="btn btn-gold">Talk to the team</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
